import axios from 'axios'

export const verifyOtp = async (token, otp) => {
  const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || 'https://pro.vibelinksapp.com/api'
  try {
    const response = await axios.post(`${BASE_URL}/verify-otp`, {
      token,
      otp
    })
    return response.data
  } catch (err) {
    return {
      success: false,
      message: err.response?.data?.message || 'Failed to verify OTPp'
    }
  }
}
